module.exports = __webpack_public_path__ + "img/v3-dollar-dark.aa8317c1.svg";